@if (isOpen) {
  <div class="ng-overlay" (keyup)="check($event)"></div>
}

@if (isOpen) {
  <div id="modal-gallery-wrapper">
    <div id="flex-min-height-ie-fix">
      <div id="modal-gallery-container">
        <header class="buttons-container">
          <a class="upper-button" (click)="close()">
            <svg-icon src="/assets/icons/general/close.svg" />
          </a>
        </header>
        <main class="main-image-container">
          <div class="left-sub-container">
            @if (images.length > 1) {
              <a class="nav-left" (click)="previousImage()">
                <svg-icon src="/assets/icons/general/chevron-left.svg" />
              </a>
            }
          </div>
          <figure id="current-figure">
            <img
              id="current-image"
              class="inside"
              [src]="$safeNavigationMigration(currentImage?.url)"
              (swipeleft)="nextImage()"
              (swiperight)="previousImage()"
            />
          </figure>
          <div class="right-sub-container">
            @if (images.length > 1) {
              <a class="nav-right" (click)="nextImage()">
                <svg-icon src="/assets/icons/general/chevron-right.svg" />
              </a>
            }
          </div>
        </main>
        <div class="spacer"></div>
      </div>
    </div>
  </div>
}
